import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { DiscountCodeGenerator } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

interface Props {
  type?: number;
  enabled?: boolean;
}

const useDiscountCodesGeneratorQuery = ({ type, enabled }: Props) => {
  const branchId = useBranchId();

  const query = useQuery<DiscountCodeGenerator[]>({
    queryKey: ["generated-discount-code", branchId, type],
    queryFn: () =>
      get2(
        `internal/secure/pos/v1/discount/codes/generator/${branchId}${
          type ? `/${type}` : ""
        }`
      ),
    enabled: enabled ?? true,
  });
  return { ...query };
};

export default useDiscountCodesGeneratorQuery;
